export default "__VITE_ASSET__DzHxlfBl__"